<div class="faq-page">
  <nav class="navbar navbar-expand-md navbar-dark bg-dark">
    <div class="sectpad container-fluid">
      <a
        class="navbar-brand logomain getlogo"
        href="javascript:void(0)"
        routerLink="/"
      >
        <img
          src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569491458/Static%20images/Logo/honest-gorilla_hduqh0.svg"
          alt="Honest Gorilla combo logo with Eva face in pink"
          title="Pink Honest Gorilla combo logo with Eva face"
          height="60"
          class="logo logohead drag-drop"
          alt="Honest Gorilla" />
        <img
          src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569491925/Static%20images/Logo/logotxt_wfug7a.svg"
          alt="Honest Gorilla logo in pink"
          title="Pink Honest Gorilla logo"
          class="logo1 mt-2"
      /></a>
      <button
        (click)="addClass($event)"
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarsExampleDefault"
        aria-controls="navbarsExampleDefault"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <img
          src="assets/images/list.png"
          width="18"
          id="menuIcon"
          class="listicn"
        />
      </button>
      <div class="collapse navbar-collapse" id="navbarsExampleDefault">
        <ul class="navbar-nav ml-auto webnav">
          <li class="nav-item active">
            <a
              class="nav-link font16 semi-bold"
              href="javascript:void(0)"
              routerLink="/commercial"
              >COMMERCIAL</a
            >
          </li>

          <li class="nav-item active" *ngIf="!showfaqus">
            <a
              class="nav-link"
              href="javascript:void(0)"
              id="faqpage"
              style="border-bottom: 2px solid #ed1976 !important"
              routerLink="['/faq','faq']"
              >FAQ</a
            >
          </li>

          <li class="nav-item active" *ngIf="showfaqus">
            <a
              class="nav-link"
              href="javascript:void(0)"
              id="faqpage"
              (click)="faqus()"
              routerLink="/faq"
              >FAQ</a
            >
          </li>
          <li class="nav-item active">
            <a
              class="nav-link font16 semi-bold"
              href="javascript:void(0)"
              routerLink="/blog"
              >BLOG</a
            >
          </li>
          <li class="nav-item active">
            <a
              class="nav-link font16 semi-bold"
              href="javascript:void(0)"
              routerLink="/giveback"
              >GIVEBACK</a
            >
          </li>

          <li class="nav-item active" *ngIf="showcontactus">
            <a
              class="nav-link font16 semi-bold"
              href="javascript:void(0)"
              routerLink="/faq/contact-us"
              (click)="contactus()"
              >CONTACT US</a
            >
          </li>

          <li class="nav-item active" *ngIf="!showcontactus">
            <a
              class="nav-link font16"
              href="javascript:void(0)"
              routerLink="/faq/contact-us"
              style="border-bottom: 2px solid #ed1976 !important"
              (click)="contactus()"
              >CONTACT US</a
            >
          </li>

          <li class="nav-item active" *ngIf="!showLogin">
            <a
              class="nav-link font16 semi-bold"
              href="javascript:void(0)"
              (click)="gotoProfile()"
              >PROFILE</a
            >
          </li>
        </ul>
        <div class="mobilenav" *ngIf="!showLogin">
          <div class="col-12 row m-0 p-0">
            <div class="col-6 col-md mb-2 mt-2">
              <h5 class="font16 semi-bold" routerLink="/">Commercial</h5>
            </div>

            <div class="col-6 col-md mb-2 mt-2">
              <h5 class="font16 semi-bold" routerLink="/faq/contact-us">
                Contact us
              </h5>
            </div>
          </div>
          <div class="col-12 row m-0 p-0">
            <div class="col-6 col-md mb-2 mt-2">
              <h5 class="font16 semi-bold" routerLink="/faq">FAQ</h5>
            </div>
            <div class="col-6 col-md mb-2 mt-2" *ngIf="!showLogin">
              <h5 class="font16 semi-bold" (click)="gotoProfile()">Profile</h5>
            </div>
          </div>
          <div class="col-12 row m-0 p-0">
            <div class="col-6 col-md mb-2 mt-2">
              <h5 class="font16 semi-bold" routerLink="/blog">Blog</h5>
            </div>

            <div class="col-6 col-md mb-2 mt-2" *ngIf="!showLogin">
              <h5
                class="font16 semi-bold"
                (click)="clearSession()"
                routerLink="/"
              >
                Logout
              </h5>
            </div>
            <div class="col-6 col-md mb-2 mt-2" *ngIf="showLogin">
              <h5 class="font16 semi-bold" routerLink="/login">Login</h5>
            </div>
            <div class="col-6 col-md mb-2 pt-1 mt-2">
              <h5 class="font16 semi-bold" routerLink="/giveback">Giveback</h5>
            </div>
          </div>

          <div class="col-12 row m-0 p-0"></div>
        </div>

        <div class="mobilenav" *ngIf="showLogin">
          <div class="col-12 row m-0 p-0">
            <div class="col-6 col-md mb-2 mt-2">
              <h5 class="font16 semi-bold" routerLink="/">Commercial</h5>
            </div>
            <div class="col-6 col-md mb-2 mt-2">
              <h5 class="font16 semi-bold" routerLink="/giveback">Giveback</h5>
            </div>
          </div>
          <div class="col-12 row m-0 p-0">
            <div class="col-6 col-md mb-2 mt-2">
              <h5 class="font16 semi-bold" routerLink="/faq">FAQ</h5>
            </div>
            <div class="col-6 col-md mb-2 mt-2">
              <h5 class="font16 semi-bold" routerLink="/faq/contact-us">
                Contact us
              </h5>
            </div>
          </div>
          <div class="col-12 row m-0 p-0">
            <div class="col-6 col-md mb-2 mt-2">
              <h5 class="font16 semi-bold" routerLink="/blog">Blog</h5>
            </div>

            <div class="col-6 col-md mb-2 mt-2" *ngIf="!showLogin">
              <h5 class="font16 semi-bold" (click)="gotoProfile()">Profile</h5>
            </div>

            <div class="col-6 col-md mb-2 mt-2" *ngIf="showLogin">
              <h5 class="font16 semi-bold" routerLink="/login">Login</h5>
            </div>
          </div>

          <div class="col-12 row m-0 p-0" *ngIf="!showLogin">
            <div class="col-6 col-md mb-2 mt-2">
              <h5 class="font16 semi-bold"></h5>
            </div>

            <div class="col-6 col-md mb-2 mt-2" *ngIf="!showLogin">
              <h5
                class="font16 semi-bold"
                (click)="clearSession()"
                routerLink="/"
              >
                Logout
              </h5>
            </div>
            <div class="col-6 col-md mb-2 mt-2" *ngIf="showLogin">
              <h5 class="font16 semi-bold" routerLink="/login">Login</h5>
            </div>
          </div>
        </div>
      </div>
      <div class="webview">
        <a
          class="btn btn-wp-primary mr-2 ml-2 login"
          *ngIf="showLogin"
          href="javascript:void(0)"
          routerLink="/login"
          >LOGIN</a
        >
        <a
          class="btn btn-wp-primary mr-2 ml-2 login"
          *ngIf="!showLogin"
          href="javascript:void(0)"
          (click)="logoutFun()"
          >LOGOUT</a
        >
      </div>
      <div class="mobileview">
        <a
          class="btn btn-wp-primary mr-2 ml-2 login"
          *ngIf="!showLogin"
          href="javascript:void(0)"
          routerLink="/get-started"
          >SHOP NOW</a
        >
      </div>

      <a
        class="btn sectbtn getstart"
        *ngIf="showLogin"
        href="javascript:void(0)"
        routerLink="/get-started"
        >SHOP NOW</a
      >
    </div>
  </nav>
</div>
